import React, { createContext, useContext } from 'react';
import useUnreadMessageCount from '../hooks/useUnreadMessageCount';

// Shares a single unread-message count + refresh across the app so that views
// which clear unread messages (e.g. opening a thread) can immediately update
// the header badge instead of waiting for the next background poll.
const UnreadMessagesContext = createContext({ count: 0, refresh: () => {} });

export const UnreadMessagesProvider = ({ enabled = true, children }) => {
  const value = useUnreadMessageCount(enabled);
  return (
    <UnreadMessagesContext.Provider value={value}>
      {children}
    </UnreadMessagesContext.Provider>
  );
};

export const useUnreadMessages = () => useContext(UnreadMessagesContext);

export default UnreadMessagesContext;
